import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_FOLKSONOMY_TOPICS = createFcmDetails('enable_folksonomy_topics', {
	// owner: '',
	context: 'homepage and discover feed',
	description: `If disabled, it will show the petition card header only if the petition topic is in the (hardcoded) allow list.
		If enabled, it will show the petition card header with any old topic.
`,
	import: false,
});
